import {
  Datagrid,
  List,
  TextField,
  TextInput,
  EditButton,
  DeleteButton,
  ReferenceField,
} from 'react-admin';

const quickReplyFilters = [
  <TextInput
    sx={{ marginBottom: 1 }}
    source="shortcut_q"
    label="resources.ticket-quick-reply.fields.shortcut"
    defaultValue=""
    key="shortcut_q"
    alwaysOn
  />,
  <TextInput
    sx={{ marginBottom: 1 }}
    source="title_q"
    label="resources.ticket-quick-reply.fields.title"
    defaultValue=""
    key="title_q"
    alwaysOn
  />,
];

export const QuickReplyList = () => {
  return (
    <List filters={quickReplyFilters}>
      <Datagrid
        bulkActionButtons={false}
        rowClick={false}
        sort={{ field: 'id', order: 'DESC' }}
      >
        <TextField source="id" label="ID" />
        <TextField
          source="shortcut"
          label="resources.ticket-quick-reply.fields.shortcut"
        />
        <TextField
          source="title"
          label="resources.ticket-quick-reply.fields.title"
        />
        <ReferenceField
          source="ticketQueueId"
          reference="ticket-queue"
          label="resources.ticket-quick-reply.fields.ticketQueueId"
          link={false}
        >
          <TextField source="name" />
        </ReferenceField>
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};
